import keyMirror from 'keymirror-nested'

export default keyMirror({
  ACCOUNTING_INFO: {
    FETCH: {
      REQUEST: null,
      SUCCEEDED: null,
      FAILED: null,
    },
    CLEAN: {
      ERRORS: null,
      STATE: null,
    },
  },
})
